module.exports = __webpack_public_path__ + "img/9788937846656.de8e9888.jpg";